import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import * as r from "../../../../constants/routes";
import { prettySubPathUrl, simplestText } from "../../../../helpers";
import UserTrainingContext from "../../../../context/userTrainingContext";
import Spinner from "../../../../components/Spinner";
import RoundButton from "../../../../components/Buttons/RoundButton";
import ButtonsArea from "../../../../components/Buttons/ButtonsArea";


export default function EndListScreen() {
    const tContext = useContext(UserTrainingContext);
    const { t } = useTranslation();
    const history = useNavigate();

    const { game_list, active_category, setGameUrl } = tContext ?? {};
    let urlCategory = ''
    if (urlCategory === "memoria") urlCategory = "Memória";
    if (urlCategory === "escuta-ativa") urlCategory = "Escuta Ativa";
    if (urlCategory === "agilidade-mental") urlCategory = "Agilidade Mental";
    if (urlCategory === "foco") urlCategory = "Foco";
    const mapBtn: { [v: string]: any } = {};

    game_list?.forEach((game: any) => {
        if (game.abilities) {
            if (game.abilities[0]) mapBtn[game.abilities[0]] = game.abilities[0];
            if (game.abilities[1]) mapBtn[game.abilities[1]] = game.abilities[1];
        }
    });
    let _content = null
    _content = <Spinner center />;
    _content = Object.keys(mapBtn).map((category: string) => {
        return (
            <RoundButton
                small
                key={category}
                text={category}
                title={category}
                onClick={() => {
                    history(r.GET_R_U_TRAIN_CAT_SMART(prettySubPathUrl(category)));
                }}
            />
        );
    });
    _content = <ButtonsArea vert>{_content}</ButtonsArea>;
    const activeCategoryAux = urlCategory;

    let title = "";
    let subtitle = "";
    switch (simplestText(activeCategoryAux)) {
        case simplestText("Escuta Ativa"):
            title = "global.title_active_listening";
            subtitle = "global.subtitle_active_listening";
            break;
        case simplestText("Memória"):
            title = "global.title_memory";
            subtitle = "global.subtitle_memory";
            break;
        case simplestText("Foco"):
            title = "global.title_focus";
            subtitle = "global.subtitle_focus";
            break;
        case simplestText("Agilidade Mental"):
            title = "global.title_mental_agility";
            subtitle = "global.subtitle_mental_agility";
            break;
        default:
            title = "global.training";
            break;
    }


    return (
        <section>{_content}</section>
    );
}